module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-6.31fcf34b.mp3";